import axios from "axios";
import "es6-promise/auto";
import VueRouter from "vue-router";
import Vuex from "vuex";
import Vue from "vue";
import { baseUrl } from "./config";
import Clipboard from "v-clipboard";
import VuePackeryPlugin from "vue-packery-plugin";
import allAtoms from "./components/_1-atoms/all";
import allMolecules from "./components/_2-molecules/all";
import allOrganisms from "./components/_3-organisms/all";
import allTemplates from "./components/_4-templates/all";
import { routerRights } from "./functions/userRights";
import i18n from "./functions/i18next";
import VueRecognizer from "vue-recognizer";
import VueSimpleContextMenu from "vue-simple-context-menu";
import "vue-simple-context-menu/dist/vue-simple-context-menu.css";
import AudioVisual from "vue-audio-visual";
import VueFit from "vue-fit";
import VuePlyr from "vue-plyr";
import "../sass/fundaments/vue-plyr.css";
import { EventBus } from "./eventbus";
import VueWaypoint from "vue-waypoint";
import VueScrollTo from "vue-scrollto";
import LottieVuePlayer from "@lottiefiles/vue-lottie-player";
import { calculateBrandColors } from "./functions/BrandingColor";

import Collections from "./components/_4-templates/Collections/Collections.vue";
import Notifications from "./components/Notifications/Notifications.vue";
import Branding from "./components/_4-templates/BrandingEdit/BrandingEdit.vue";
import Account from "./components/_4-templates/Account/Account.vue";
import Billing from "./components/_4-templates/Billing/Billing.vue";
import Users from "./components/_4-templates/Users/Users.vue";
import InviteAccepted from "./components/_4-templates/InviteAccepted/InviteAccepted.vue";
import TransferDownload from "./components/_4-templates/TransferDownload/TransferDownload.vue";
import NoPage from "./components/_4-templates/NoPage/NoPage.vue";
import Policy from "./components/_4-templates/Policy/Policy.vue";
import Plan from "./components/_4-templates/Plan/Plan.vue";
import NotificationOverview from "./components/_4-templates/NotificationOverview/NotificationsOverview.vue";
import SearchFull from "./components/_4-templates/SearchFull/SearchFull.vue";
import CollectForDownload from "./components/_4-templates/CollectForDownload/CollectForDownload.vue";
import Spaces from "./components/_4-templates/Spaces/Spaces.vue";
import Bin from "./components/_4-templates/Bin/Bin.vue";

import Login from "./components/_4-templates/MobileLogin/MobileLogin.vue";
import MobileTransfer from "./components/_4-templates/MobileTransfer/MobileTransfer.vue";
import MobileUpload from "./components/_4-templates/mobileUpload/MobileUpload.vue";
import Home from "./components/_4-templates/Home/Home.vue";
import DesktopFiles from "./components/_4-templates/DesktopFiles/DesktopFiles.vue";
import DesktopSpaces from "./components/_4-templates/DesktopSpaces/DesktopSpaces.vue";
import CollectionDetail from "./components/_4-templates/CollectionDetail/CollectionDetail.vue";
import Pwa from "./components/_4-templates/Pwa/Pwa.vue";

Vue.config.runtimeCompiler = true;

//Catching errors in push replace
//Of course, errors in replace can be captured the same way
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => err);
};

Vue.prototype.$axios = new axios.create({
  baseURL: "https://sheprd.app/api/",
  timeout: 30000,
});

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(Clipboard);
Vue.use(VuePackeryPlugin);
Vue.use(VueRecognizer);
Vue.use(AudioVisual);
Vue.use(VueFit);
Vue.use(VuePlyr);
Vue.use(VueWaypoint);
Vue.use(VueScrollTo);
Vue.use(LottieVuePlayer);

//add components
allAtoms();
allMolecules();
allOrganisms();
allTemplates();

Vue.component("vue-simple-context-menu", VueSimpleContextMenu);

/*
 * Routing
 */

const router = new VueRouter({
  mode: "history",
  hashbang: false,
  linkActiveClass: "active",
  routes: [
    { path: "/404", component: NoPage },
    {
      path: "/pwa",
      component: Pwa,
      meta: {
        rights: [],
      },
    },
    { path: "/:company", component: Home },
    { path: "/:company/", component: Home },
    { path: "/:company/reset", component: Home, name: "resetpass" },
    { path: "/:company/userforget", component: Home },
    { path: "/:company/home", component: DesktopSpaces },
    { path: "/:company/home/expanded/:id", component: DesktopFiles },
    { path: "/:company/home/expanded/:id/:file", component: DesktopFiles },
    {
      path: "/:company/home/expanded/:id/:file/:detail",
      component: DesktopFiles,
    },
    {
      path: "/:company/bin",
      component: DesktopFiles,
      meta: {
        rights: [],
      },
    },
    {
      path: "/:company/bin/:file",
      component: DesktopFiles,
      meta: {
        rights: [],
      },
    },
    {
      path: "/:company/bin/:file/:detail",
      component: DesktopFiles,
      meta: {
        rights: [],
      },
    },
    { path: "/:company/search/:query", component: SearchFull, name: "Search" },
    {
      path: "/:company/search/:query/:file",
      component: SearchFull,
      name: "Search",
    },
    {
      path: "/:company/myspace",
      component: DesktopFiles,
      meta: {
        rights: ["my-space"],
      },
    },
    {
      path: "/:company/myspace/expanded/:id",
      component: DesktopFiles,
      meta: {
        rights: ["my-space"],
      },
    },
    {
      path: "/:company/myspace/expanded/:id/:file",
      component: DesktopFiles,
      meta: {
        rights: ["my-space"],
      },
    },
    {
      path: "/:company/myspace/expanded/:id/:file/:detail",
      component: DesktopFiles,
      meta: {
        rights: ["my-space"],
      },
    },
    {
      path: "/:company/collections",
      component: Collections,
      meta: {
        rights: ["collect"],
      },
    },
    {
      path: "/:company/collection/expanded/:id",
      component: CollectionDetail,
      meta: {
        rights: ["collect"],
      },
    },
    {
      path: "/:company/collection/expanded/:id/:file",
      component: CollectionDetail,
    },
    { path: "/:company/collect-for-download", component: CollectForDownload },
    {
      path: "/:company/account",
      component: Account,
      meta: {
        rights: [],
      },
    },
    {
      path: "/:company/branding",
      component: Branding,
      meta: {
        rights: ["edit_branding"],
      },
    },
    // {path: '/:company/settings', component: Settings},
    {
      path: "/:company/billing",
      component: Billing,
      meta: {
        rights: [],
      },
    },
    {
      path: "/:company/plan",
      component: Plan,
      meta: {
        rights: [],
      },
    },
    {
      path: "/:company/notifications",
      component: Notifications,
      meta: {
        rights: [],
      },
    },
    {
      path: "/:company/invite-accepted",
      component: InviteAccepted,
      meta: {
        rights: [],
      },
    },
    {
      path: "/:company/users/:invite",
      component: Users,
      meta: {
        rights: ["edit_users"],
      },
    },
    {
      path: "/:company/users",
      component: Users,
      meta: {
        rights: ["edit_users"],
      },
    },
    {
      path: "/:company/policy",
      component: Policy,
      meta: {
        rights: [],
      },
    },
    { path: "/:company/transfer/:transfer", component: TransferDownload },
    // { path: '/:company/about', component: About },
    // { path: '/:company/help', component: Help },
    // { path: '/:company/help/:name', component: Questions },
    // { path: '/:company/contact', component: Contact },
    { path: "/:company/spaces", component: Spaces },
    { path: "/:company/login", component: Login },
    {
      path: "/:company/notifications-overview",
      component: NotificationOverview,
    },
    { path: "/:company/mobile-transfer", component: MobileTransfer },
    { path: "/:company/mobile-transfer/:step", component: MobileTransfer },
    {
      path: "/:company/upload",
      component: MobileUpload,
      meta: {
        rights: ["create_files", "create_folders"],
      },
    },
    {
      path: "/:company/upload/:step",
      component: MobileUpload,
      meta: {
        rights: ["create_files", "create_folders"],
      },
    },
  ],
});

/*
 * Storage
 */

let company_full = null;
let user = null;
let company = null;
let role = null;

const checkExist = (companyName) => {
  companyName = companyName || window.location.pathname.split("/")[1];
  if (companyName !== "pwa") {
    return fetch(`${baseUrl}/company?company=${companyName}`)
      .then((r) => r.json())
      .then((r) => {
        company_full = r;
        company_full.isBilling = checkBilling(companyName);

        //set brand color
        if (company_full.brand_color) {
          calculateBrandColors(company_full.brand_color);
        } else {
          calculateBrandColors("#000000");
        }

        //set new og image
        const ogImage = document.querySelector("meta[name=og\\:image]");

        if (ogImage) {
          ogImage.setAttribute("content", company_full.home_screen);
        }
      })
      .catch(() => {
        setupApp();
        if (companyName !== "pwa") {
          router.push("/404");
        }
      });
  }

  return fetch("/");
};

function checkBilling($company) {
  if (
    $company == "poa" ||
    $company == "ethnicraft" ||
    $company == "hedgren" ||
    $company == "alimento" ||
    $company == "sheprd"
  ) {
    return 0;
  } else {
    return 1;
  }
}

const getRole = () => {
  const id = user ? user.role_id : null;
  if (id) {
    return fetch(`${baseUrl}/role?id=${id}&company=${company ? company : null}`)
      .then((r) => r.json())
      .then((r) => {
        role = r.role;

        return r.role;
      })
      .catch(() => {
        //logout
        wipeUserData();
      });
  }

  return new Promise((resolve) => {
    resolve(true);
  });
};

const wipeUserData = () => {
  localStorage.setItem(company + "_" + "user", JSON.stringify(null));
  localStorage.setItem(company + "_" + "folder_myspace", JSON.stringify(null));
  localStorage.setItem(company + "_" + "folder_spaces", JSON.stringify(null));
};

//protect the routes
router.beforeEach((to, from, next) => {
  //resize window
  setCustomVh();

  if (!user) {
    user = JSON.parse(localStorage.getItem(company + "_" + "user"));
  }

  const currentRights = user
    ? user.rights
    : company_full
    ? company_full.public.rights
    : [];

  let neededRights = [];

  to.matched.some((rec) => {
    neededRights = rec.meta.rights ? rec.meta.rights : [];
  });

  if (!routerRights(neededRights, currentRights, user)) {
    next(`/${company}`);
  }

  next();
});

const setupApp = () => {
  const store = new Vuex.Store({
    state: {
      user: user,
      role: role,
      company: company,
      company_full: company_full,
      public: company_full ? company_full.public : null,
      tile: JSON.parse(localStorage.getItem("tile")),
      isMobile: window.innerWidth < 540,
      isTabletPortrait: window.innerWidth <= 786 && window.innerWidth >= 540,
      isSmallScreen: window.innerWidth <= 1024 && window.innerWidth > 786,
      isLoading: true,
      isUploading: false,
      isTransfering: false,
      transferItems: { selectedFiles: [], selectedFolders: [], collection: {} },
      isUploadingMobile: false,
      uploadFiles: [],
      uploadFolderInfo: {},
      selectorMode: {
        active: false,
        startValue: false,
      },
      collectForDownload: localStorage.getItem("collectForDownload")
        ? JSON.parse(localStorage.getItem("collectForDownload"))
        : [],
    },
    mutations: {
      updateResize(state) {
        state.isMobile = window.innerWidth < 540;
        state.isTabletPortrait =
          window.innerWidth <= 786 && window.innerWidth >= 540;
        state.isSmallScreen =
          window.innerWidth <= 1024 && window.innerWidth > 786;
      },
    },
  });

  window.addEventListener("resize", () => {
    store.commit("updateResize");

    setCustomVh();
  });

  //register any mouse up
  window.addEventListener("mouseup", () => {
    store.state.selectorMode = {
      active: false,
      startValue: false,
    };
  });

  /*
   * Axios config
   */
  let pendingRequests = [];
  Vue.prototype.$axios.defaults.params = {};
  Vue.prototype.$axios.defaults.params["company"] = store.state.company;
  Vue.prototype.$axios.defaults.timeout = 100000000000;
  Vue.prototype.$axios.interceptors.response.use(
    (response) => {
      removeHashFromPendingAndReleaseBody(response.config.requestHash);
      return response;
    },
    (error) => {
      removeHashFromPendingAndReleaseBody(error.response.config.requestHash);
      // comment the if to catch the error
      /* if (error.response.status === 401) {
        //user has no permissions so logout user
        store.state.user = null;
        Vue.prototype.$axios.defaults.params["key"] = null;
        localStorage.setItem(company + "_" + "user", JSON.stringify(null));
        localStorage.setItem(
          company + "_" + "folder_spaces",
          JSON.stringify(null)
        );
        localStorage.setItem(
          company + "_" + "folder_myspace",
          JSON.stringify(null)
        );
        router.push("/" + company);
        EventBus.$emit("login"); //Trust me this has te be here ;)
      }*/
      return Promise.reject(error);
    }
  );
  Vue.prototype.$axios.interceptors.request.use(
    (config) => {
      let $path = config.url.split("/")[4];

      //On request init don't allow anymore userclicks
      if ($path != "transferadd") {
        let $body = document.getElementsByTagName("body")[0];
        if (!$body.classList.contains("no-clicks")) {
          $body.classList.add("no-clicks");
        }
      }

      store.state.isLoading = true;
      //Creating a unique requestHash and adding it to our pending requests
      config.requestHash = Math.random().toString(36).substr(2, 8);
      pendingRequests.push(config.requestHash);
      //Continueing
      if (localStorage.getItem("uploading") == "true") {
        store.state.isUploading = true;
      }

      return config;
    },
    (error) => {
      if (error.response.status === 401) {
        //user has no permissions so logout user
        store.state.user = null;
        Vue.prototype.$axios.$axios.defaults.params["key"] = null;
        localStorage.setItem(
          store.state.company + "_" + "user",
          JSON.stringify(null)
        );
        localStorage.setItem(
          store.state.company + "_" + "folder_spaces",
          JSON.stringify(null)
        );
        localStorage.setItem(
          store.state.company + "_" + "folder_myspace",
          JSON.stringify(null)
        );
        router.push("/" + store.state.company);
        EventBus.$emit("login"); //Trust me this has te be here ;)
      }

      return Promise.reject(error);
    }
  );

  function removeHashFromPendingAndReleaseBody(hash) {
    //Removing the request from our pending requests list (Because we received a response)
    pendingRequests.splice(pendingRequests.indexOf(hash), 1);
  }

  if (store.state.user) {
    Vue.prototype.$axios.defaults.params["key"] = store.state.user.key;
  }

  /*
   * The App
   */
  Vue.mixin({
    data() {
      return {
        get publicUser() {
          return store.state.public
            ? store.state.public
            : {
                rights: [],
              };
        },
      };
    },
  });

  // eslint-disable-next-line no-unused-vars
  const app = new Vue({
    router,
    i18n,
    store,
  }).$mount("#app");
};

export const setup = (init = true, companyName) => {
  companyName = companyName || window.location.pathname.split("/")[1];

  if (companyName) {
    checkExist(companyName)
      .then((r) => {
        company = companyName;

        user = JSON.parse(localStorage.getItem(company + "_" + "user"));

        if (user) {
          if (user.company !== companyName || !user.rights) {
            wipeUserData();
          }
        }

        return r;
      })
      .then(() => {
        //check if user oke and get role
        if (init) {
          getRole().then(() => {
            setupApp();
          });
        }
      });
  } else {
    router.push("/404");
  }
};

setup();

/*
 * Copy thing
 */

/*var clipboard = new ClipboardJS(".copy-link");
clipboard.on("success", (e) => {
  const confirmcopy = document.querySelector("confirmcopy");
  confirmcopy.style.display = "block";
  // $(".confirmcopy").css("display", "block");
  //$(".confirmcopy").next().css("display", "none");
  e.clearSelection();
});*/

console.log("Thu 05/12 09:45");
console.log(
  "%c SHEPRD is currently in BETA version.\n\n",
  'font-family: "Circular Std",sans-serif; color: white; background: black; font-size: 24px;'
);

localStorage.setItem("uploading", false);
window.onbeforeunload = function (event) {
  if (localStorage.getItem("uploading") == "true") {
    event = event || window.event;
    if (event) {
      event.returnValue = "Sure?";
    }
    return "Sure?";
  }
};

/**
 * Check if the list view is set
 */
if (localStorage.getItem("tile") === null) {
  localStorage.setItem("tile", JSON.stringify(false));
}

//fullscreen function
const setCustomVh = () => {
  document.documentElement.style.setProperty(
    "--vh",
    `${window.innerHeight / 100}px`
  );
};

setCustomVh();

window.addEventListener("beforeunload", function (event) {
  event.stopImmediatePropagation();
});

window.alert = function () {};
